import { BehaviorSubject } from 'rxjs';
import { fetchWrapper , history } from '@helpers';

const usuarioSubject = new BehaviorSubject(null);
const baseUrl = `/usuario`;

export const usuarioService = {
    login,
    getUsersInactives,
    logout,
    refreshToken,
    register,
    verifyUser,
    deleteInactiveUser,
    forgotPassword,
    validateResetToken,
    resetPassword,
    getById,
    update,
    usuario: usuarioSubject.asObservable(),
    get usuarioValue () { return usuarioSubject._value }
};

function login(email, password) {
 
    return fetchWrapper.post(`${baseUrl}/authenticate`, { email, password })
        .then(usuario => {
            //publicar el usuario a los suscriptores e iniciar el temporizador para actualizar el token
            usuarioSubject.next(usuario);
            startRefreshTokenTimer();
            return usuario;
        });
}

function getUsersInactives (payload) {
    const skip = parseInt(payload.skip);
    const take = parseInt(payload.take);
    return fetchWrapper.post(`${baseUrl}/get-users-inactives`, {
        skip,
        take,
    });
}

function logout() {
        // revoke token, stop refresh timer, publish null to user subscribers and redirect to login page
        fetchWrapper.post(`${baseUrl}/revoke-token`, {});
        stopRefreshTokenTimer();
        usuarioSubject.next(null);
        history.push('/usuario/login');
}

function refreshToken() {
    return fetchWrapper.post(`${baseUrl}/refresh-token`, {})
        .then(usuario => {
            // publicar el usuario a los suscriptores e iniciar el temporizador para actualizar el token
            usuarioSubject.next(usuario);
            startRefreshTokenTimer();
            return usuario;
        })
}


function register(params) {
    return fetchWrapper.post(`${baseUrl}/register`, params);
}

function verifyUser(token) {
    return fetchWrapper.post(`${baseUrl}/verify-user`, { token });
}

function deleteInactiveUser(idUsuario) {
    return fetchWrapper.post(`${baseUrl}/delete-inactive-user`, { idUsuario });
}

function forgotPassword(email) {
    return fetchWrapper.post(`${baseUrl}/forgot-password`, { email });
}

function validateResetToken(token) {
    return fetchWrapper.post(`${baseUrl}/validate-reset-token`, { token });
}

function resetPassword(payload ) {
    const token = payload.token;
    const password = payload.password;
    const confirmPassword = payload.confirmacionPassword;
    return fetchWrapper.post(`${baseUrl}/reset-password`, {token,password,confirmPassword} );
}



function getById(id) {
   
    return fetchWrapper.get(`${baseUrl}/${id}`);
}



function update(payload) {
    const {idUsuario , data} = payload;
    const id = idUsuario;
    return fetchWrapper.post(`${baseUrl}/${id}`, data)
        .then(usuario => {
            // update stored usuario if the logged in usuario updated their own record
            if (usuario.id === usuarioSubject.value.id) {
                // publish updated usuario to subscribers
                usuario = { ...usuarioSubject.value, ...usuario };
                usuarioSubject.next(usuario);
            }
            return usuario;
        });
}


// helper functions
let refreshTokenTimeout;

//esta funcion activa un temporizador que vence un minuto antes de que expire el token
function startRefreshTokenTimer() {
    // parse json object from base64 encoded token

    if(usuarioSubject) {
        if(usuarioSubject.value) {
            if(usuarioSubject.value.token) {
                const token = JSON.parse(atob(usuarioSubject.value.token.split('.')[1]));

                // set a timeout to refresh the token a minute before it expires
                const expires = new Date(token.exp * 1000);
                const timeout = expires.getTime() - Date.now() - (60 * 1000);
                
            
                refreshTokenTimeout = setTimeout(refreshToken, timeout);
            }
        }
       
    }


}

//esta funcion limpia el temporizador
function stopRefreshTokenTimer() {
    clearTimeout(refreshTokenTimeout);
}




